import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {FormHelperService} from '../../../../shared/services/person/form-helper-service';
import * as _ from 'lodash';
import {AddAgeRangesService} from '../../../../shared/services/nso-data-portal/add-services/add-age-ranges-service';
import {AgeGroupsTypes} from '../../../../shared/types/nso-data-portal/age-groups-types';
import {GlobalMessagesService} from '../../../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'wsd-add-age-range',
  templateUrl: './add-age-range.component.html',
  styleUrls: ['./add-age-range.component.css']
})
export class AddAgeRangeComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<any>();

  ageRange: any;

  ageRangeForm: UntypedFormGroup;

  display = false;

  show: boolean;

  constructor(private addService: AddAgeRangesService,
              private formHelper: FormHelperService,
              private fb: UntypedFormBuilder,
              private message: GlobalMessagesService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.ageRangeForm = this.fb.group({
      groupType: ['', Validators.required],
      ageGroupName: ['', [Validators.required, Validators.max(255)]],
      startingAge: ['', [Validators.required, Validators.pattern(/^(0|[1-9]\d*)?$/), Validators.max(255)]],
      endingAge: ['', [Validators.required, Validators.pattern(/^(0|[1-9]\d*)?$/), Validators.max(255)]]
    });
    this.addService.messageSent$.subscribe(
      (ageRange: any) => {
        this.ageRange = ageRange;
        this.ageRangeForm.reset();
        this.ageRangeForm.patchValue(ageRange);
        this.checkWhichGroupType(this.ageRangeForm.get('groupType').value);
        this.display = true;
      }
    );
  }

  onChange() {
    this.checkWhichGroupType(this.ageRangeForm.get('groupType').value);
  }

  checkWhichGroupType(groupType: string) {
    if (groupType === AgeGroupsTypes.ADULTS) {
      this.ageRangeForm.get('startingAge').clearValidators();
      this.ageRangeForm.get('startingAge').updateValueAndValidity();
      this.ageRangeForm.get('endingAge').clearValidators();
      this.ageRangeForm.get('endingAge').updateValueAndValidity();
      this.show = false;
    } else {
      this.ageRangeForm.get('startingAge').setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)?$/), Validators.max(255)]);
      this.ageRangeForm.get('startingAge').updateValueAndValidity();
      this.ageRangeForm.get('endingAge').setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)?$/), Validators.max(255)]);
      this.ageRangeForm.get('endingAge').updateValueAndValidity();
      this.show = true;
    }
  }

  save() {
    this.formHelper.validateAllFormFields(this.ageRangeForm);
    if (this.ageRangeForm.invalid) {
      return;
    }

    if (!(this.ageRangeForm.get('endingAge').value >= this.ageRangeForm.get('startingAge').value)) {
      this.handleError();
      return;
    }

    _.assign(this.ageRange, this.ageRangeForm.value);
    this.display = false;
    this.onSave.emit(this.ageRange);
  }

  private handleError() {
    this.message.showErrorMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.SAVE_DATES_ERROR_MESSAGE'));
  }

}
